export default __webpack_public_path__ + "_/sounds/bet_result-b3731c130a50a6b86c7b4a713ffea0226b0d55b771d25c34cb17a2892ad912f2.mp3";